<header class="tw:inline-block tw:w-full">
    <lib-heading-header><ng-content></ng-content></lib-heading-header>
    <hr class="tw:border-t-[#333] tw:h-[.1rem] tw:mt-2" />
</header>
